import script from "./HomeProducto.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeProducto.vue?vue&type=script&setup=true&lang=js"

import "./HomeProducto.vue?vue&type=style&index=0&id=2401d86c&lang=css"

const __exports__ = script;

export default __exports__